import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, Router, RouterStateSnapshot } from "@angular/router";
import { UserPermissions } from "./permissions.enum";
import { AppState } from "../store";
import { Store } from "@ngrx/store";
import { filter, map, take } from "rxjs";
import { selectUserInfo } from "../store/user/user.reducer";


@Injectable()
export class PermissionsGuard implements CanActivate {

  private router = inject(Router);
  private store = inject(Store<AppState>);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<GuardResult> {
    return this.store.select(selectUserInfo).pipe(
      filter(userInfo => userInfo !== undefined && userInfo !== null),
      take(1),
      map((userInfo) => {
        if (userInfo?.Roles) {
          const userPermissions = userInfo.Roles.flatMap(role => role.Permissions);
          const requiredPermissions = route.data['permissions'];

          const hasAllPermissions = (userPermissions: string[], requiredPermissions: string[]) => {
            return requiredPermissions.every(p => userPermissions.includes(p) || userPermissions.includes(UserPermissions.ADMIN_ALL));
          };

          if (hasAllPermissions(userPermissions, requiredPermissions)) {
            return true;
          }
        }

        // Redirect to access denied page
        this.router.navigate(['/access-denied']);
        return false;
      })
    )

  }
}
